module.exports = __webpack_public_path__ + "static/media/kid27.508e2721.png";